(function(){
    'use strict';

    angular.module('app').
    controller('AdminDeleteModalController', AdminDeleteModalController);

    AdminDeleteModalController.$inject=[
        '$uibModalInstance',
        'data',
        'AdminPermissionService'

    ]

    function AdminDeleteModalController($uibModalInstance,data,AdminPermissionService){
        const vm = this;
        vm.yes = confirm;
        vm.dismiss = modalDismiss;
        vm.close = close;

        function modalDismiss(){
            $uibModalInstance.close()
        }

        function confirm(){
           
            AdminPermissionService.AdminCurrentUser.deleteAdminUserAccount(
                res=>{
                    vm.success = true;
                    //$uibModalInstance.dismiss()
                },
                err=>{
                    console.log(err)
                },
                data
            )
            
        }

        function close(){
            $uibModalInstance.close(vm.success);
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/administration/modal/adminDeleteModalController.js